import { Box } from '@mui/material';
import { useAtomValue } from 'jotai';
import { Outlet } from 'react-router-dom';
import { authUserAtom, sidebarCollapsedAtom, useCompany, useUserByCognitoIdentity } from '@consentropy/shared';
import { TopBar } from './TopBar';
import { Sidebar, SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_WIDTH } from './Sidebar';

export function AppShell() {
  const collapsed = useAtomValue(sidebarCollapsedAtom);
  const authUser = useAtomValue(authUserAtom);
  const { data: currentUser } = useUserByCognitoIdentity(authUser?.id, authUser?.username);
  const companyId = currentUser?.companyId ?? '';
  const { data: company } = useCompany(companyId);
  const sidebarWidth = collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Sidebar />
      <TopBar companyName={company?.name} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: `${sidebarWidth}px`,
          mt: '64px',
          transition: 'margin-left 0.2s ease',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
